"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../utils/classNames");
const Divider = (props) => {
    const { direction = 'row', className } = props;
    const baseClassName = (0, classNames_1.cn)(className);
    if (direction === 'row') {
        return (0, jsx_runtime_1.jsx)("div", { className: `border-t border-gray-200 ${baseClassName}` });
    }
    return (0, jsx_runtime_1.jsx)("div", { className: ` border-l border-gray-200  ${baseClassName}` });
};
exports.Divider = Divider;
